export const homepageContent = {
  hero: {
    title: "Keep your family organized and connected",
    subtitle: "Stop being the family information hub. FamilyCast centralizes schedules, tasks, and updates so you can focus on enjoying time with your loved ones.",
    cta: "Join Early Beta",
    logoAlt: "FamilyCast Logo"
  },
  valuePropositions: [
    {
      title: 'Simplify Family Organization',
      subtitle: 'Keep everyone on the same page',
      description: 'Stop being the family information hub. FamilyCast centralizes schedules, chores, and updates so you can focus on enjoying time with your loved ones instead of managing them.',
      benefits: ['Shared Family Calendar', 'Chore Management', 'Automated Reminders', 'Everyone Stays Informed'],
      iconName: 'CalendarToday'
    },
    {
      title: 'Keep Everyone Connected',
      subtitle: 'Create a central family hub',
      description: "Transform your home into a connected space where everyone knows what's happening—from today's schedule to this week's meals and upcoming events.",
      benefits: ['Real-Time Updates', 'Visual Schedules', 'Family Announcements', 'Shared Task Lists'],
      iconName: 'People'
    },
    {
      title: 'Make It Your Own',
      subtitle: 'Customize for your family',
      description: 'Easy-to-use tools that let you create beautiful displays showing exactly what your family needs to see, from photos and weather to tasks and calendars.',
      benefits: ['Custom Layouts', 'Photo Sharing', 'Weather & News', 'Family-Friendly Content'],
      iconName: 'Palette'
    }
  ],
  problem: {
    title: "We Understand Your Challenges",
    subtitle: "Because we've been there too",
    paragraphs: [
      "In today's busy world, keeping your family organized and connected feels like a full-time job. Sticky notes get lost, family members miss appointments, and important information doesn't reach everyone. Digital calendars help, but they require everyone to check their phones constantly.",
      "That's why we've built FamilyCast—a central family hub that transforms how your household communicates. Our platform ensures everyone sees the most relevant information exactly when they need it, from today's schedule to this week's chores, leading to better coordination and less stress for everyone.",
      "We know that managing a busy family is hard enough without juggling calendars, to-do lists, and keeping everyone informed. That's why we've made it our mission to eliminate this chaos so you can focus on what really matters - spending quality time together and making memories."
    ]
  },
  beta: {
    title: "Be Among the First",
    subtitle: "Join our exclusive beta program and help shape the future of family organization",
    description: "Get early access to cutting-edge features, special pricing, and direct interaction with our development team. Help us build the perfect solution for your family needs.",
    cta: "See What's Waiting for You"
  },
  whatWeDo: {
    title: "What We Do",
    subtitle: "Focus on what matters most - your family and your time together"
  },
  commandCenter: {
    title: "Your Family's Digital Command Center",
    subtitle: "Modern families need more than sticky notes and shared calendars",
    paragraphs: [
      "Picture Sarah, a working mom of three. Every morning starts with chaos—who has soccer practice? When's the dentist appointment? Did we remember to buy milk? She used to manage everything through scattered apps, text messages, and handwritten notes on the fridge.",
      "Now, Sarah's family has a FamilyCast display in their kitchen. The kids check their chore lists while eating breakfast. Her husband glances at today's schedule before heading out. Everyone sees the week's meal plan, upcoming birthdays, and even motivational quotes to start the day right. The weather forecast helps them decide what to wear, and family photos rotate throughout the day, keeping everyone connected even when they're apart.",
      "Or consider Mark and his college-aged daughter who share a home. They use FamilyCast to coordinate their schedules, share grocery lists, display news feeds they both care about, and even show countdowns to important events like her graduation. Their display becomes a conversation starter—\"Did you see the weather forecast for the weekend?\" or \"Your calendar shows you have that interview tomorrow—good luck!\"",
      "Whether you're managing a busy household with kids, coordinating with roommates, or keeping elderly parents informed about family activities, FamilyCast adapts to your needs. Display calendars from multiple family members, rotate through cherished photos, show task lists that update in real-time, integrate weather and news that matters to you, or create custom content that reflects your family's unique personality. It's not just a display—it's your family's central hub for staying connected, organized, and in sync."
    ]
  },
  integration: {
    title: "Powerful Content Integration",
    subtitle: "Connect any data source and create dynamic, engaging displays",
    features: [
      {
        title: "Universal Calendar Support",
        description: "Integrate with any iCal-based calendar system. Google Calendar, Outlook, Apple Calendar, or custom solutions - all supported with multiple display formats.",
        items: ["iCal Integration", "Multiple Views", "Real-time Updates"],
        iconName: 'CalendarToday'
      },
      {
        title: "Advanced Layout Designer",
        description: "Drag-and-drop interface to create pixel-perfect layouts. Assign different content types to specific areas with custom styling and positioning.",
        items: ["Drag & Drop", "Area Management", "Custom Styling"],
        iconName: 'DisplaySettings'
      },
      {
        title: "Rich Content Ecosystem",
        description: "Support for text, images, videos, slides, inventory data, employee schedules, and more. Everything you need for comprehensive home communication.",
        items: ["Multi-format", "Dynamic Data", "Real-time Sync"],
        iconName: 'ContentCopy'
      }
    ]
  },
  finalCta: {
    title: "Ready to Give Your Family the Gift of Organization?",
    subtitle: "Give your family more time together and less time managing schedules. Let's make it happen!",
    cta: "Let's Get Started Together! 🎉"
  },
  footer: {
    copyright: "© 2025 FamilyCast. All rights reserved.",
    cookiePreferences: "Cookie Preferences"
  }
};
